export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'goals', getter: () => import(/* webpackChunkName: "text" */ 'components/bolt/text/text'), component: 'text', parent: 'boltHome' },
	{ id: 'boltToutVertical', getter: () => import(/* webpackChunkName: "toutVertical" */ 'components/bolt/toutVertical/toutVertical'), component: 'toutVertical', parent: 'boltHome' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "gallery" */ 'components/bolt/gallery/gallery'), component: 'gallery', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
